//Overrides
Panel.prototype.SetOutputData = function (oData) {
    this._outputData = oData;
    this._processOutputDataPoints();
    this._dataCoordCache = {};
    this.SetHeight(oData.Size.Height);
    this.SetWidth(oData.Size.Width);
    this._setMarkers();
};
Panel.prototype._setMarkers = function () {
    if (!this._checkIsPricePanel()) {
        //$("div.remove", this._markerContainer).remove();
        this._markerContainer.addClass("lowerPanel");
        this._markerContainer.append(this._getPanelRemoveControl());
    } else {
        this._markerContainer.addClass("upperPanel");
    }
};
Panel.prototype._getPanelRemoveControl = function () {
    return $("<span class='icon-remove'></span>")
		.on("click", this._handleRemoveAction.eventContext(this));
};
// Event Handlers
Panel.prototype._handleRemoveAction = function () {
    this._chart.RemovePanel(this);
    this._chart.Update();
    $("div.advanced-chart-header li[data-uid=" + this.GetUID() + "]").removeClass("selected");
};
Panel.prototype.Remove = function () {
    this._panelContainer.remove();
};
//Misc
Panel.prototype._checkIsPricePanel = function () {
    return this._chart.GetPricePanel().GetUID() == this.GetUID();
};